

import state from './moduleClientsState.js'
import mutations from './moduleClientsMutations.js'
import actions from './moduleClientsActions.js'
import getters from './moduleClientsGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

